module.exports = __webpack_public_path__ + "static/img/guide-topico2.1ec3a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide-topico2.png
// module id = 3c93
// module chunks = 1